import cx from 'classnames';
import { Menu } from '@base-ui/react';
import { Icon } from '../icon/Icon';
import styles from './Kebab.scss';
import typography from '~styles/typography.scss';

export enum KebabMenuItemVariant {
  Pink = 'pink',
}

export interface KebabOption
  extends Omit<React.HTMLAttributes<HTMLElement>, 'children'> {
  label: string;
  disabled?: boolean;
  variant?: KebabMenuItemVariant;
}

export interface KebabProps {
  triggerLabel?: string;
  ariaLabelPrefix?: string;
  options?: KebabOption[];
  side?: 'left' | 'right' | 'top' | 'bottom';
  triggerClassName?: string;
  showIcon?: boolean;
}

export const Kebab = ({
  triggerLabel,
  ariaLabelPrefix,
  options = [],
  side = 'left',
  triggerClassName,
  showIcon = true,
}: KebabProps) => (
  <Menu.Root>
    <Menu.Trigger
      className={cx(styles.button, triggerClassName)}
      aria-label={[ariaLabelPrefix, 'options'].join(' ').trim()}
      onClick={(e) => {
        // Ensure opening the menu does not bubble to React ancestors
        // rendered outside the menu
        e.stopPropagation();
      }}
    >
      {triggerLabel && <span className={typography.h7_20}>{triggerLabel}</span>}
      {showIcon && <Icon name="options" ariaLabel="options" />}
    </Menu.Trigger>
    <Menu.Portal>
      <Menu.Positioner
        className={styles.positioner}
        side={side}
        sideOffset={14}
      >
        <Menu.Popup
          className={styles.popup}
          onClick={(e) => {
            // Ensure clicks inside the popup (including on disabled items)
            // do not bubble to React ancestors rendered outside the portal
            e.stopPropagation();
          }}
        >
          <Menu.Arrow className={styles.arrow}>
            <Icon name="arrowPopover" />
          </Menu.Arrow>
          {options.map(({ label, variant, ...props }) => (
            <Menu.Item
              key={label}
              {...props}
              className={styles.menuItem}
              data-variant={variant}
            >
              {label}
            </Menu.Item>
          ))}
        </Menu.Popup>
      </Menu.Positioner>
    </Menu.Portal>
  </Menu.Root>
);
